import { __ } from '@wordpress/i18n';
import {VayuBlocksCssFilters, VayuBlockBorderFrame, VayuBlocksBackground} from '@vayu-blocks';
import { useState} from '@wordpress/element';
import { PanelBody, RangeControl } from '@wordpress/components';
import { SlideButton } from '@vayu-blocks/global';

const Style = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const [hover, sethover] = useState('normal');
    
    const handelHover = (value) => {
        sethover(value);
    }

    return (
        
        <>

            <PanelBody
                title={__('Background/Filter', 'vayu-blocks')}
                opened={openPanels['lottie-filter']}
                onToggle={() => onTogglePanel('lottie-filter')}
                className='vb-lottie-style-panel'
            >
                
                <SlideButton  
                    button={{ normal: "Normal", hover: "Hover" }}
                    onChange={(value)=>handelHover(value)}
                    defaultValue={hover}
                /> 

                {hover === 'normal' && (
                    <>
                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            headingLabel = "Background"
                            colorPanel = {[
                                {
                                    active: ['gradient'],
                                    label: 'Lottie',
                                    key:'background',
                                    value:attributes.background,
                                },
                            ]}
                        />

                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={__('Opacity', 'vayu-blocks')}
                            max={1}
                            min={0}
                            step={0.1}
                            allowReset={true}
                            marks
                            withInputField={false}
                            value={attributes.opacity}
                            onChange={(value) => setAttributes({opacity: value})}
                        />

                        
                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={__('Transition', 'vayu-blocks')}
                            max={3}
                            min={0}
                            step={0.3}
                            allowReset={true}
                            marks
                            withInputField={false}
                            value={attributes.transition}
                            onChange={(value) => setAttributes({transition: value})}
                        />

                        <VayuBlocksCssFilters 
                            data = {{key: 'filter', value:attributes.filter}}
                            onChange={(key,value)=>setAttributes({[key]:value})}
                        />
                    </>
                )} 

                {hover === 'hover' && (
                    <>

                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            headingLabel = "Background"
                            colorPanel = {[
                                {
                                    active: ['gradient'],
                                    label: 'Hover',
                                    key:'backgroundhvr',
                                    value:attributes.backgroundhvr,
                                },
                            ]}
                        />

                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={__('Opacity', 'vayu-blocks')}
                            max={1}
                            min={0}
                            step={0.1}
                            marks
                            withInputField={false}
                            allowReset={true}
                            value={attributes.opacityhvr}
                            onChange={(value) => setAttributes({opacityhvr: value})}
                        />

                        
                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={__('Transition', 'vayu-blocks')}
                            max={3}
                            min={0}
                            step={0.3}
                            allowReset={true}
                            marks
                            withInputField={false}
                            value={attributes.transition}
                            onChange={(value) => setAttributes({transition: value})}
                        />

                        <VayuBlocksCssFilters 
                            data = {{key: 'hoverfilter', value:attributes.hoverfilter}}
                            onChange={(key,value)=>setAttributes({[key]:value})}
                        />
                    </>
                )} 

            </PanelBody>

            <PanelBody 
                title={__('Border Frame','vayu-blocks')} 
                opened={openPanels['slide-frame']} 
                onToggle={() => onTogglePanel('slide-frame')}
            >

                <VayuBlockBorderFrame
                    frameData={attributes.frameData}
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    dataKey="frameData"
                />
                 
            </PanelBody>

        </>

    );
};

export default Style;